/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './resistance-trend.reducer';

export const ResistanceTrendDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const resistanceTrendEntity = useAppSelector(state => state.resistanceTrend.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="resistanceTrendDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.resistanceTrend.detail.title">ResistanceTrend</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.id">Id</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.id}</dd>
          <dt>
            <span id="resistanceRate">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.resistanceRate">Resistance Rate</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.resistanceRate}</dd>
          <dt>
            <span id="trendPeriod">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.trendPeriod">Trend Period</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.trendPeriod}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.active">Active</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.resistanceTrend.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{resistanceTrendEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.resistanceTrend.testReference">Test Reference</Translate>
          </dt>
          <dd>{resistanceTrendEntity.testReference ? resistanceTrendEntity.testReference.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.resistanceTrend.organism">Organism</Translate>
          </dt>
          <dd>{resistanceTrendEntity.organism ? resistanceTrendEntity.organism.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.resistanceTrend.antibiotic">Antibiotic</Translate>
          </dt>
          <dd>{resistanceTrendEntity.antibiotic ? resistanceTrendEntity.antibiotic.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/resistance-trend" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/resistance-trend/${resistanceTrendEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ResistanceTrendDetail;
